module.exports = __webpack_public_path__ + "img/wip.4d4dab8f.png";